module.exports = __webpack_public_path__ + "static/imgVacancie3-ef329b92b84a08dff82fac3d0ecb0f3c.png";